export const getEventPaymentsFromState = (state) => {
  const { eventPayments, additionalServices, paymentMethods } = state;
  return { eventPayments, additionalServices, paymentMethods };
};

export const getMerchantInfo = (state) => {
  const { merchant } = state;
  return { merchant };
};

export const getRefundFromState = (state) => {
  const { refund } = state;
  return { refund };
};
